import { CLEAR_LIST } from 'root/src/client/logic/api/actionIds'

export default payload => ({
	type: CLEAR_LIST,
	payload,
})
